import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const faqs = [{
  q: '¿Sirve para Provincia de Buenos Aires?',
  a: 'Sí. Está alineado al Diseño Curricular de la Provincia de Buenos Aires y a los NAP nacionales. Los contenidos, la secuencia y las evaluaciones respetan el programa oficial de Física secundaria.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Inmediatamente después del pago recibís un mail con el link de descarga. Acceso en menos de 5 minutos, a cualquier hora, desde cualquier dispositivo. Sin esperar.'
}, {
  q: '¿Es editable?',
  a: 'Los archivos son PDF de alta resolución, listos para imprimir. No son editables para mantener el diseño y la marca Guía Digital 360. Los podés imprimir, fotocopiar y usar libremente en tu aula.'
}, {
  q: '¿Funciona para escuelas con pocos recursos de laboratorio?',
  a: 'Sí, especialmente. Todos los experimentos fueron diseñados con materiales de bajo costo (menos de $2.000 ARS por actividad). Celular, regla, vaso de agua y pila son suficientes para la mayoría.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés 7 días de garantía total. Si por cualquier motivo el material no cumple tus expectativas, escribinos a soporteguiadigital360@gmail.com y te devolvemos el 100% del dinero. Sin preguntas, sin vueltas.'
}, {
  q: '¿Los proyectos del Tomo 7 son para cualquier año?',
  a: 'Sí. El Tomo 7 está diseñado para 1° a 6° año, con 15 proyectos clasificados por nivel de dificultad y año recomendado. Desde el periscopio (1°-2°) hasta la Casa Sustentable (5°-6°), todos con guía de presentación al jurado incluida.'
}, {
  q: '¿El Pack VIP incluye todo?',
  a: 'Sí. El Pack VIP ($24.990) incluye los 7 Tomos + los 3 Bonos + la Bóveda de Evaluación 360 (40 modelos de exámenes, rúbricas, planillas RITE y solucionarios). Es el sistema completo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-78">
      <div className="max-w-3xl mx-auto" data-id="element-79">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-8 md:mb-12" data-id="element-80">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-81">
          {faqs.map((faq, index) => <div key={index} className="border-2 border-gray-100 rounded-xl overflow-hidden shadow-sm" data-id="element-82">
              <button className="w-full px-6 py-5 text-left bg-gray-50 hover:bg-gray-100 transition-colors flex justify-between items-center" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-83">
                <span className="font-bold text-lg text-brand-dark pr-4" data-id="element-84">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUpIcon className="w-6 h-6 text-brand-orange flex-shrink-0" data-id="element-85" /> : <ChevronDownIcon className="w-6 h-6 text-gray-400 flex-shrink-0" data-id="element-86" />}
              </button>

              {openIndex === index && <div className="px-6 py-5 bg-white text-gray-700 text-lg leading-relaxed border-t border-gray-100" data-id="element-87">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}